/* @flow */
import * as React from 'react';
import styled from 'styled-components';

import { Box, Flex, Text } from '@sonyged/proc-ui';
import css from '@styled-system/css';

import { Pizza } from '../../pizza/fields/domain/pizza';
import { Stars } from './Stars';
import { ingredientName } from './constants';
import AutoScaleContainer from '../../pizza/fields/AutoScaleContainer';
import PizzaContainer from '../../pizza/fields/PizzaContainer';

type Props = {
  pizza: Pizza,
  star: number,
  sale: number,
};

export function YesterdayPizzaPanel(props: Props) {
  let { pizza, star, sale } = props;

  return (
    <Container>
      <Content>
        <Flex>
          <PizzaCell>
            <AutoScaleContainer
              preferedHeight={600}
              preferedMinHeight={600}
              preferedWidth={1080}
              preferedMinWidth={1080}
            >
              <PizzaContainer pizza={pizza} />
            </AutoScaleContainer>
          </PizzaCell>
          <Box>
            {[pizza.crust, pizza.sauce].concat(pizza.toppings).map((ingredient, i) => (
              <IngredientName key={i}>{ingredientName(ingredient)}</IngredientName>
            ))}
          </Box>
        </Flex>

        <SaleInfoContainer>
          <SaleInfoContent>
            <Box>
              売り上げ　　　： <Price>{sale}</Price>円
            </Box>
            <Box>
              お店のひょうか： <Stars stars={star} />
            </Box>
          </SaleInfoContent>
        </SaleInfoContainer>
      </Content>
    </Container>
  );
}

const Container = styled(Box)(
  css({
    display: 'flex',
    justifyContent: 'center',
    bg: 'white',
    borderRadius: [8, 8, 15],
    width: '100%',
    maxWidth: [440, 440, 800],
    px: [28, 28, 70],
    py: [28, 28, 70],
    // iPhone SE
    '@media screen and (max-width: 360px)': {
      px: 18,
      py: 18,
    },
  })
);

const Content = styled(Box)(
  css({
    flex: 1,
    maxWidth: [314, 314, 536],

    '>* + *': {
      mt: [18, 18, 24],
    },
  })
);

const PizzaCell = styled(Box)(
  css({
    display: 'flex',
    width: [124, 155, 264],
    height: [72, 90, 136],

    '&&& .pizza-container': {
      top: 0,
      left: 0,
      right: 0,
      height: '100%',
      width: '100%',
    },
  })
);

const IngredientName = styled(Text)(
  css({
    display: 'block',
    color: 'secondary120',
    fontSize: [14, 14, 18],
    lineHeight: 'title',
  })
);

const SaleInfoContainer = styled(Box)(
  css({
    display: 'flex',
    justifyContent: 'center',
    bg: 'gray10',
    borderRadius: [4, 4, 6],
  })
);

const SaleInfoContent = styled(Box)(
  css({
    pb: [18, 18, 24],
    pt: ['6px', '6px', '8px'],
    fontSize: [14, 14, 22],
    lineHeight: 'title',
    color: 'gray100',
  })
);

const Price = styled(Text)(
  css({
    fontSize: [28, 28, 34],
  })
);
